<div class="input-number" [style.margin-bottom]="messagePad" [style.width]="width" [class.hide-arrows]="!showArrows">
  <div class="p-field">
    <label [for]="name" [style.width]="labelWidth">
      {{ label }}
      <app-label-icon *ngIf="labelIcon" [data]="labelIcon" />
      <app-icon
        *ngIf="tooltip"
        [icon]="tooltip.icon"
        [appTooltip]="tooltip"
        [size]="ICON_SIZE"
        [colour]="ICON_COLOUR"
      />
    </label>
    <div class="p-container">
      <input
        #input
        appReadOnly
        [style.width]="inputWidth"
        #model="ngModel"
        [(ngModel)]="value"
        [name]="name"
        (ngModelChange)="onChange($event)"
        type="number"
        [min]="min"
        [max]="max"
        [attr.min]="min"
        [attr.max]="max"
        [attr.step]="step"
        [placeholder]="placeholder"
        [required]="required"
        [disabled]="isDisabled"
        [class.has-errors]="displayErrors"
        [class.has-suffix]="!!suffix"
        [attr.aria-invalid]="displayErrors"
        [attr.aria-describedby]="displayErrors ? name + '-error' : null"
        (blur)="onBlur()"
        (focus)="onFocusInput()"
        (keypress)="onInputKeyDown($event)"
        [ignoreReadOnly]="ignoreReadOnly"
        pInputText
      />
      <div class="suffix" [ngClass]="{ 'top-margin': !!label }" *ngIf="suffix">{{ suffix }}</div>
    </div>
    <div class="error-container" *ngIf="displayErrors" [attr.id]="name + '-error'" role="alert" aria-atomic="true">
      <span *ngFor="let error of errors" class="p-error">{{ error }}</span>
    </div>
  </div>
  <div class="message-container" *ngIf="footerMessage">
    {{ footerMessage }}
  </div>
</div>
